import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { LazyLoadComponent } from '@src/components/LazyLoadComponent/LazyLoadComponent';

const ProfilePage = lazy(() =>
    import('../../pages/Profile').then((module) => ({
        default: module.Profile,
    }))
);

export function ProfileContainer() {
    return (
        <Routes>
            <Route
                path={'*'}
                element={
                    <LazyLoadComponent
                        type="PAGE"
                        Component={<ProfilePage />}
                    />
                }
            />
        </Routes>
    );
}
